export type RingPattern = "incoming" | "outgoing";

let context: AudioContext | null = null;
let stopCurrent: (() => void) | null = null;

function audioContextConstructor(): typeof AudioContext | null {
  if (typeof AudioContext !== "undefined") return AudioContext;
  return (
    (globalThis as { webkitAudioContext?: typeof AudioContext })
      .webkitAudioContext ?? null
  );
}

/** ユーザー操作中に呼ぶと、Safari を含むブラウザで後の着信音を再生できる。 */
export function unlockCallAudio(): void {
  const Constructor = audioContextConstructor();
  if (!Constructor) return;
  if (!context) {
    try {
      context = new Constructor();
    } catch {
      return;
    }
  }
  if (context.state === "suspended")
    void context.resume().catch(() => undefined);
}

/** 二音を1秒鳴らし、2秒休む着信音。音声ファイルを読み込まない。 */
export function startCallRingtone(pattern: RingPattern = "incoming"): void {
  stopCallRingtone();
  unlockCallAudio();
  if (!context || context.state !== "running") return;
  const current = context;
  const gain = current.createGain();
  gain.gain.value = 0;
  gain.connect(current.destination);
  const frequencies = pattern === "incoming" ? [520, 660] : [440];
  const peak = pattern === "incoming" ? 0.1 : 0.045;
  const oscillators = frequencies.map((frequency) => {
    const oscillator = current.createOscillator();
    oscillator.type = "sine";
    oscillator.frequency.value = frequency;
    oscillator.connect(gain);
    oscillator.start();
    return oscillator;
  });

  const burst = (): void => {
    const now = current.currentTime;
    gain.gain.cancelScheduledValues(now);
    gain.gain.setValueAtTime(0, now);
    gain.gain.linearRampToValueAtTime(peak, now + 0.02);
    gain.gain.setValueAtTime(peak, now + 0.98);
    gain.gain.linearRampToValueAtTime(0, now + 1);
  };
  burst();
  const timer = window.setInterval(burst, 3_000);
  stopCurrent = () => {
    window.clearInterval(timer);
    const now = current.currentTime;
    gain.gain.cancelScheduledValues(now);
    gain.gain.setValueAtTime(gain.gain.value, now);
    gain.gain.linearRampToValueAtTime(0, now + 0.02);
    for (const oscillator of oscillators) {
      oscillator.stop(now + 0.04);
      oscillator.onended = () => oscillator.disconnect();
    }
    window.setTimeout(() => gain.disconnect(), 200);
  };
}

export function stopCallRingtone(): void {
  const stop = stopCurrent;
  stopCurrent = null;
  if (!stop) return;
  try {
    stop();
  } catch {
    // 音声コンテキストがブラウザ側で破棄済みなら、追加の後始末は不要。
  }
}
